export const REQUEST_FEEDBACK_MESSAGE_TYPE = "REQUEST_FEEDBACK_MESSAGE_TYPE";
export const SET_FEEDBACK_MESSAGE_TYPE = "SET_FEEDBACK_MESSAGE_TYPE";
